import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from 'store/actions/evaluation-questions.action'
import * as fromNormalQuestionAction from 'store/actions/questions.action'
import { createLikertQuestion } from 'api/administration/questions/Create'
import { getQuestionList } from 'api/administration/questions/List'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { BlockTypes } from 'enum/block-type.enum'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import { IQuestionLikertModel } from 'models/questionLikert.model'

const pattern = fromActions.EVALUATION_QUESTION_LIKERT_CREATE

async function getList(instanceId: number) {
  return await getQuestionList(instanceId)
}

function handleCreateLicker(data: any) {
  return createLikertQuestion(data)
}

function* newLikertEffectSaga(
  action: ActionWithPayload<
    typeof pattern,
    fromActions.QuestionLikertCreatePayload
  >
) {
  try {
    const {
      payload: {
        questionData: {
          text,
          explanationAnswer,
          order,
          link: { url, type },
          options,
        },
        id,
        instanceId,
      },
    } = action

    const aux: IQuestionLikertModel<BlockTypes.BlockEvaluation> = {
      likert: {
        likertLabelsAttributes:
          options?.map(({ text, checked }, index: number) => ({
            label: text,
            order: index,
            checked,
          })) || [],
      },
      question: {
        name: text,
        description: '',
        mandatory: true,
        explanationAnswer,
        order,
        blockInstanceableId: id,
        blockInstanceableType: BlockTypes.BlockEvaluation,
        url,
        urlType: type,
      },
    }

    yield call(handleCreateLicker, aux)
    const questionList = yield call(getList, instanceId)
    yield put(
      fromNormalQuestionAction.Actions.questionsListSuccess(questionList)
    )
  } catch (error) {
    yield put(fromNormalQuestionAction.Actions.setQuestionLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.createError'))
    console.log('error: ', error)
  }
}

export function* createEvaluationLikertWatcherSaga() {
  yield takeLatest(pattern, newLikertEffectSaga)
}
